import React from 'react'
import PropTypes from 'prop-types'

import { connect } from 'react-redux'
import config from '../../config'
import { Iframe } from '../../components'

const RenderTool = (props) => {
    const {
        match: {
            params: { project = '' },
        },
        selectedEstate,
        sessionToken,
    } = props

    const url = `${config.app.adcreateUrl}/#/${project}?t=${sessionToken}&e=${selectedEstate}`

    return <Iframe src={url} />
}

RenderTool.propTypes = {
    match: PropTypes.shape({
        params: PropTypes.shape({
            project: PropTypes.string,
        }),
    }).isRequired,
    selectedEstate: PropTypes.string.isRequired,
    sessionToken: PropTypes.string.isRequired,
}

const mapStateToProps = ({
    app: { selectedEstate },
    user: {
        session: { sessionId: sessionToken },
    },
}) => ({ selectedEstate, sessionToken })

export default connect(mapStateToProps, null)(RenderTool)
